/*
 * @Author: edvardchen
 * @Date: 2018-01-17 14:58:22
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-11-27 17:17:36
 */

// @flow
import querystring from 'query-string';
import { redirect, getQBVersion } from '../utility';

let currentTop = 0;
let originTop = 0;
// only be called on Android
window.x5CommentBtnClick = (passParams = {}) => {
  console.log('passParams :>> ', passParams);
  let el = null;
  if (!el) {
    el = document.getElementById('comments');
  }
  if (!el) {
    console.warn('no comment list found');
  }
  window._kdBigTReportInstance?.report('commentClick');
  if (!el || el.offsetHeight < 100) {
    try {
      const queryObj = querystring.parse(window.location.search);
      const { docId = '' } = queryObj;
      if (!docId || getQBVersion() < 1000) {
        return;
      }
      const passParamsEncodeStr = encodeURIComponent(JSON.stringify(passParams));
      const contenturl = `https://news.html5.qq.com/commentpageold/${docId}`;
      redirect(
        `qb://ext/read?alonecmturl=${contenturl}&module=infocontent&component=infocontent&&passParams=${passParamsEncodeStr}`,
      );
    } catch (error) {}
    return;
  }
  const top = el.offsetTop;
  const { pageYOffset } = window;
  if (currentTop !== top && pageYOffset !== top) {
    currentTop = top;
    originTop = pageYOffset;
    window.scrollTo(0, currentTop);
  } else {
    currentTop = originTop;
    window.scrollTo(0, currentTop);
  }
};
